/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import * as React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";

import Button from "../../../reusable/button";
import CancelModal from "./cancelModal";
import styled from "styled-components";
import { CancelTrialCardPropTypes } from "../lib/types";
import { StyledParagraph } from "../lib/styles";
import { redesignTheme } from "../../../theme/theme";

const StyledContainer = styled.div`
  background: ${redesignTheme.color.gray50};
  border-radius: ${redesignTheme.radius.lg};
  padding: ${redesignTheme.spacing[2.5]} ${redesignTheme.spacing[3.5]};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const StyledButton = styled(Button)`
  display: inline-block;
`;

const CancelTrialCard = ({
  updateToastMessage,
}: CancelTrialCardPropTypes): React.ReactElement => {
  const [modal, setModal] = React.useState<string>("");
  return (
    <StyledContainer data-testid="cancel-trial-card">
      <StyledParagraph>
        {i18n.translate("admin_pages.settings.not_interested")}
      </StyledParagraph>
      <StyledButton
        onClick={(): void => {
          return setModal("cancel");
        }}
        size="small"
        testId="cancel-trial-button"
        variant="secondary"
      >
        {i18n.translate("admin_pages.settings.cancel_trial")}
      </StyledButton>
      <CancelModal
        closeModal={() => setModal("")}
        modal={modal}
        updateToastMessage={updateToastMessage}
      />
    </StyledContainer>
  );
};

export default CancelTrialCard;
